/**
 * Initialize filter logic.
 */
export default () => {
	// Event handler for clicking tax links
	const taxLinks = document.querySelectorAll('.js-gsfc-filter-tax-link');
	taxLinks.forEach((taxLink) => {
		taxLink.addEventListener('click', async function (e) {
			e.preventDefault();
			const slug = this.dataset.slug;
			process(slug);
		});
	});

	// Load filters for each tax link
	taxLinks.forEach(load);

	// Iterate through each form group
	const formGroups = document.querySelectorAll('.form-group');
	formGroups.forEach((formGroup) => {
		const formChecks = formGroup.querySelectorAll('.form-check');
		const numFormChecks = formChecks.length;
		const numHidden = numFormChecks - 5;

		// Toggle form-checks if there are more than 5
		if (numHidden > 0) {
			formChecks.forEach((formCheck, index) => {
				if (index >= 5) {
					formCheck.style.display = 'none';
				}
			});
			const toggleLink = document.createElement('a');
			toggleLink.href = '#';
			toggleLink.classList.add(
				'js-gsfc-toggle-form-checks',
				'd-block',
				'mb-1'
			);
			toggleLink.textContent = 'Show More';
			const toggleButton = document.createElement('button');
			toggleButton.classList.add(
				'js-gsfc-toggle-form-checks',
				'p-0',
				'ms-auto'
			);
			toggleButton.textContent = 'Show';

			formGroup.querySelector('.filter-panel').appendChild(toggleLink);
			formGroup.querySelector('.form-label').appendChild(toggleButton);

			// Click event handler for toggle link
			toggleLink.addEventListener('click', function (e) {
				e.preventDefault();
				formChecks.forEach((formCheck, index) => {
					if (index >= 5) {
						formCheck.style.display =
							formCheck.style.display === 'none'
								? 'block'
								: 'none';
					}
				});
				formGroup
					.querySelector('.filter-panel')
					.classList.toggle('open');
				updateCheckToggles(toggleLink, toggleButton);
			});

			// Click event handler for toggle button
			toggleButton.addEventListener('click', function (e) {
				e.preventDefault();
				formChecks.forEach((formCheck, index) => {
					if (index >= 5) {
						formCheck.style.display =
							formCheck.style.display === 'none'
								? 'block'
								: 'none';
					}
				});
				formGroup
					.querySelector('.filter-panel')
					.classList.toggle('open');
				updateCheckToggles(toggleLink, toggleButton);
			});
		}
	});
};

/**
 * Update toggle text based on visibility.
 *
 * @param {HTMLElement} toggleLink   The toggle link element.
 * @param {HTMLElement} toggleButton The toggle button element.
 */
const updateCheckToggles = (toggleLink, toggleButton) => {
	if (toggleLink.textContent === 'Show More') {
		toggleLink.textContent = 'Show Less';
		toggleButton.textContent = 'Hide';
	} else {
		toggleLink.textContent = 'Show More';
		toggleButton.textContent = 'Show';
	}
};

/**
 * Process the filter based on the provided slug.
 *
 * @param {string} slug The slug of the filter to process.
 */
const process = (slug) => {
	const formGroups = document.querySelectorAll(
		'.js-gsfc-filters .form-group'
	);
	formGroups.forEach((formGroup) => (formGroup.style.display = 'none'));
	document.querySelector('.js-gsfc-filter-draw-evidence').style.display =
		'none';
	document.querySelector('.js-gsfc-filter-draw-publication').style.display =
		'none';

	const targetedFormGroups = document.querySelectorAll(
		'.js-gsfc-filters .form-group[data-parent-term="' + slug + '"]'
	);
	targetedFormGroups.forEach(
		(formGroup) => (formGroup.style.display = 'block')
	);
	document
		.querySelectorAll('.js-gsfc-filters .form-group[data-parent-term=""]')
		.forEach((formGroup) => (formGroup.style.display = 'block'));

	document.querySelector('.js-gsfc-filter-draw-' + slug).style.display =
		'block';
};

/**
 * Load filters based on the provided element.
 *
 * @param {HTMLElement} element The element representing the filter.
 */
const load = (element) => {
	const tax = element.dataset.tax;
	const value = element.dataset.value;

	if (global.filters.taxonomies[tax] !== undefined) {
		const index = global.filters.taxonomies[tax].terms.findIndex(
			(item) => item[0] === value
		);
		if (index > -1) {
			element.classList.add('active');
			process(element.dataset.slug);
		}
	}
};
